module.exports = __webpack_public_path__ + "img/frame (85).8db24bda.jpg";